import React, { useState } from 'react';
import '../../css/cards/Membership.css';

import { AiFillQuestionCircle } from 'react-icons/ai';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { useDispatch } from 'react-redux';

import { openTrainingMore } from '../../features/training';
import SupportInitiative from '../SupportInitiative';
import SimpleModal from '../modals/SimpleModal';

const Membership = ({
	image,
	icon,
	title,
	priceUSD,
	prices,
	price_before,
	urls,
	items,
	country,
}) => {
	const dispatch = useDispatch();
	const [modal, setModal] = useState(false);

	const [url, setUrl] = useState('');
	const [close, setClose] = useState(true);

	const closeModal = () => setModal(false);

	const handlerClose = (url) => {
		setUrl(url);
		close ? setClose(false) : setClose(true);
	};

	const handleCloseModal = (event) => {
		if (event.target.className === 'Inscriptions ') {
			setClose(true);
		}
	};

	return (
		<div className='Membership'>
			<SimpleModal
				close={close}
				handlerClose={handlerClose}
				handleCloseModal={handleCloseModal}
				url={url}
			/>
			<div className='membership-header'>
				<img src={image} alt='Header Membership' />
			</div>
			<div className='membership-body'>
				<div className='membership-info'>
					<div className='membership-icon'>
						<img src={icon} alt='Membership Icon' />
					</div>
					<div className='membership-name'>
						<h4 style={title === 'Full Plan' ? { color: '#6000de' } : { color: '#000000' }}>
							{title}
						</h4>
						<h5>
							${priceUSD}
							<br />
							<sub>${price_before.ALL}</sub>
						</h5>
					</div>
				</div>

				<ul className='membership-card-items'>
					{/* <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						<select className='price-select' name='price' id='price'>
							<option hidden={true} value=''>
								Ver precios por país
							</option>
							{prices.map((e, i) => (
								<option key={i} value={e.price}>
									{e.price}
								</option>
							))}
						</select>
						<AiFillQuestionCircle
							className='description-question'
							onClick={() => {
								setModal(true);
							}}
						/>
					</div> */}
					{items.map((e, i) => (
						<li
							key={i}
							style={
								e.item === 'Acceso adicional al campamento.'
									? { fontWeight: 700 }
									: { fontWeight: 300 }
							}
						>
							<IoCheckmarkCircle style={{ fontSize: 20, marginRight: 20 }} />
							{e.item}
							{e.more ? (
								<AiFillQuestionCircle
									className='question-icon'
									onClick={() => {
										dispatch(
											openTrainingMore({
												modal: true,
												title: e.item,
												more: e.more,
											})
										);
									}}
								/>
							) : null}
						</li>
					))}
				</ul>
				<div className='membership-button'>
					<a
						onClick={() => handlerClose(urls[0])}
						//  target={'_blank'}
						rel='noreferrer'
						className={urls[0].class}
					>
						{urls[0].name}
					</a>
					{urls[1] ? (
						<a
							onClick={() => handlerClose(urls[1])}
							// target={'_blank'}
							rel='noreferrer'
							className={urls[1].class}
						>
							{urls[1]?.name}
						</a>
					) : null}
				</div>
			</div>
			<SupportInitiative modal={modal} closeModal={closeModal} />
		</div>
	);
};

export default Membership;
